/* (c) Dalineage, s.r.o. 2020-2025, all rights reserved */
package com.dalineage.client.adt

import com.dalineage.common

import org.scalajs.dom

object TreeExplorerADT {
  trait TreeExplorerUserAction

  case class DeleteBatch(node: TreeNode, dir:String) extends TreeExplorerUserAction
  case class NodeSelected(node: TreeNode) extends TreeExplorerUserAction
  case class NodeOpened(node: TreeNode) extends TreeExplorerUserAction
  case class ExplorerKeyboardEvent(e: dom.KeyboardEvent) extends TreeExplorerUserAction
  case class DownloadOriginal(node: TreeNode) extends TreeExplorerUserAction
  case class SwitchFocus() extends TreeExplorerUserAction

  trait NodeType

  case class TreeNode(
    `type`: NodeType,
    key: String,
    name: String,
    properties: List[PropertyPanelADT.Property],
    children: List[TreeNode] = List(),
    expanded: Boolean = false, //for leaf (=batch) it indicates if it is selected
  ) {
    def data: List[(String, String)] = //compat
      properties.filter(_.isInstanceOf[PropertyPanelADT.KeyValue]).map {
        case PropertyPanelADT.KeyValue(key, value, None) => (key, value)
        case _ => throw new Exception(s"assertion failed") //old stuff is only KeyValue
      }
  }

  //compat
  object TreeNodeCompat {
    def apply(
      `type`: NodeType,
      key: String,
      name: String,
      data: List[(String, String)],
      children: List[TreeNode] = List(),
      expanded: Boolean = false,
    ): TreeNode = {
      val properties: List[PropertyPanelADT.Property]
        = data.map { case (key, value) => PropertyPanelADT.KeyValue(key, value, None) }
      TreeNode(`type`, key, name, properties, children, expanded)
    }
  }
}
